/**
 * Homepage tracking snippet.
 *
 * Records consented visits and invite requests in the first-party
 * public.funnel_events table, with a new/returning flag.
 */
import { trackFunnelEvent } from "@/lib/funnelAnalytics";
import { getVisitorIdentity } from "@/lib/visitor";
import { hasAnalyticsConsent } from "@/lib/analyticsConsent";

/** Record a homepage visit. Fire-and-forget. */
export const trackHomepageVisit = (): void => {
  if (!hasAnalyticsConsent()) return;
  const { visitorId, isNewVisitor, firstSeen } = getVisitorIdentity();

  void trackFunnelEvent("landing_view", {
    visitor_id: visitorId,
    is_new_visitor: isNewVisitor,
    first_seen: firstSeen,
  });

};

/** Record an invite request submission (or duplicate). */
export const trackInviteRequest = (
  outcome: "submitted" | "duplicate",
  metadata: Record<string, unknown> = {},
): void => {
  if (!hasAnalyticsConsent()) return;
  const { visitorId, isNewVisitor } = getVisitorIdentity();

  void trackFunnelEvent(
    outcome === "submitted" ? "access_request_submitted" : "access_request_duplicate",
    { ...metadata, visitor_id: visitorId, is_new_visitor: isNewVisitor },
  );
};
